import { Injectable } from '@angular/core';
import { Params }     from '@angular/router';

@Injectable({ providedIn: 'root' })
export class QueryParamsService {
  private initialParams: Params = {};

  setAll(params: Params) {
    this.initialParams = { ...params };
  }

  get(key: string): string | null {
    return this.initialParams[key] ?? null;
  }

  getAll(): Params {
    return { ...this.initialParams };
  }
}
